'use client'
import * as React from 'react'
import { tw } from 'utils/classnames'
import { Link } from '@repo/web-ui/components/link'

interface StyledLinkProps {
  active?: boolean
}

export function FeedLink({
  active,
  ...props
}: StyledLinkProps & React.ComponentProps<typeof Link>) {
  return (
    <Link
      {...props}
      href={props.href}
      className={tw(
        'text-md',
        'flex flex-row items-center font-normal leading-6',
        'hover:text-cf-turquoise-green',
        active && 'text-secondary-700 font-medium',
        props.className,
      )}
    >
      {props.children}
    </Link>
  )
}
